import React from 'react';
import {Link} from 'react-router-dom';
import {CenteredHeader, CenteredInfo, CenteredLayout} from '../../layout/centered/components';
import MessageBox from '../components/MessageBox';

const RegistrationConfirmation: React.FC = () => {
  return (
    <CenteredLayout sectionId="registration-confirmation-section">
      <CenteredHeader
        title="Check Your Email"
        subtitle="Registration successful"
      />

      <MessageBox
        icon="fa fa-envelope-open"
        message="A confirmation email has been sent to your email address. Please check your mailbox and click on the confirmation link to activate your account."
      />

      <CenteredInfo className="mt-8">
        Already confirmed your email?&nbsp;
        <Link
          className="text-gray-800 hover:underline cursor-pointer font-medium"
          to="/login"
        >
          Sign in here
        </Link>
      </CenteredInfo>
    </CenteredLayout>
  );
};

export default RegistrationConfirmation;

